import React from "react";
import {
  Button,
  CircularProgress,
  Stack,
  TextField,
} from "@mui/material";

const EmailForm = ({
  email,
  setEmail,
  formErrors,
  handleGetOTP,
  loading,
  appName,
}) => {
  return (
    <div className="ax-sso-form">
      <header className="ax-sso-form-head">
        <h1>Sign in</h1>
        <p>
          {appName
            ? `to continue to ${appName}`
            : "to continue to your workspace"}
        </p>
      </header>

      <Stack spacing={2}>
        <TextField
          fullWidth
          type="email"
          value={email}
          error={Boolean(formErrors.email)}
          helperText={formErrors.email || " "}
          onChange={(event) => setEmail(event.target.value)}
          label="Work email"
          placeholder="name@company.com"
          autoComplete="email"
          autoFocus
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              handleGetOTP();
            }
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "10px",
              backgroundColor: "var(--ax-surface)",
              fontSize: "0.95rem",
              height: 50,
            },
            "& .MuiInputLabel-root": {
              fontSize: "0.92rem",
            },
          }}
        />

        <Button
          fullWidth
          variant="contained"
          onClick={handleGetOTP}
          disabled={loading}
          aria-label="Continue with AuthX"
          sx={{
            height: 50,
            borderRadius: "10px",
            backgroundColor: "var(--ax-blue)",
            fontSize: "0.95rem",
            fontWeight: 600,
            letterSpacing: "-0.005em",
            "&:hover": {
              backgroundColor: "var(--ax-blue-hover)",
            },
          }}
        >
          {loading ? (
            <CircularProgress size={20} sx={{ color: "#fff" }} />
          ) : (
            "Continue with AuthX"
          )}
        </Button>
      </Stack>

      <p className="ax-sso-helper">
        We&rsquo;ll send a one-time code to your inbox &middot; no password
        required.
      </p>
    </div>
  );
};

export default EmailForm;
